import { defaultConfig, defineSlotRecipe } from '@chakra-ui/react';

import merge from 'lodash/merge';

export const popoverSlotRecipe = defineSlotRecipe(
    merge(defaultConfig?.theme?.slotRecipes?.popover, {}),
);
